import React, { useState } from 'react';

import { IoMdClose } from 'react-icons/io';
import { CgMenuRight } from 'react-icons/cg';
import LinkedIn from '../assets/socials/linkedin.svg';

import GitHub from '../assets/socials/github.svg';

import { Link } from 'react-router-dom';

import { motion } from 'framer-motion';

const menuVariants = {
  hidden: {
    x: '100%',
  },
  show: {
    x: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.9],
    },
  },
};

const MobileNav = () => {
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <nav className="text-primary xl:hidden bg-stone-100">
      <div
        onClick={() => setOpenMenu(true)}
        className="text-3xl cursor-pointer"
      >
        <CgMenuRight />
      </div>

      <motion.div
        variants={menuVariants}
        initial="hidden"
        animate={openMenu ? 'show' : ''}
        className="bg-white shadow-2xl w-full absolute top-0 right-0 max-w-xs h-screen z-20"
      >
        <div
          onClick={() => setOpenMenu(false)}
          className="text-4xl absolute z-30 left-4 top-14 text-primary cursor-pointer"
        >
          <IoMdClose />
        </div>
        <ul className="h-full flex flex-col justify-center items-center gap-y-8 text-primary font-primary font-bold text-3xl">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/skills">Skills</Link>
          </li>
          <li>
            <Link to="/portfolio">Projects</Link>
          </li>
          <hr />
          <li>
            <span className="grid grid-cols-2">
              <a
                href="https://www.linkedin.com/in/kameshwaran-e-10350a22b/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3  block rounded transition-all duration-500"
              >
                <img src={LinkedIn} alt="" className="w-10 h-10" />
              </a>

              <a
                href="https://github.com/Kameshwaran-E"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3  block rounded transition-all duration-500"
              >
                <img src={GitHub} alt="" className="w-10 h-10" />
              </a>
            </span>
          </li>
        </ul>
      </motion.div>
    </nav>
  );
};

export default MobileNav;
